import { post } from './base';

// 认证相关类型定义
export interface RegisterData {
  username: string;
  password: string;
  email?: string;
  phone?: string;
  languagePreference: string;
}

export interface LoginData {
  username: string;
  password: string;
}

export interface AuthResponse {
  userId: string;
  token: string;
}

// 认证API服务
export const authApi = {
  // 注册
  register: async (data: RegisterData): Promise<AuthResponse> => {
    return post<AuthResponse>('/auth/register', data);
  },

  // 登录
  login: async (data: LoginData): Promise<AuthResponse> => {
    return post<AuthResponse>('/auth/login', data);
  },

  // 登出
  logout: async (): Promise<void> => {
    return post<void>('/auth/logout');
  },
};
